// internal
import { ProjectType } from '@app/store/typings/actions/project.d';
import { ProjectState } from '@app/store/typings/state/project.d';

const initState: ProjectState = {
  id: '',
  name: '',
  data: [],
  currentProject: {
    _id: '',
    picture: '',
    groups: [],
    roles: [],
    addresses: [],
    name: '',
    brandId: '',
    status: '',
    users: [],
    contact: {
      phone: '',
      email: '',
      fax: '',
      link: '',
    },
    createdAt: '',
    updatedAt: '',
  },
  meta: {
    limit: 0,
    offset: 0,
    total: 0,
  },
  listRole: {
    data: [],
    meta: {
      limit: 0,
      offset: 0,
      total: 0,
    },
    currentRole: {
      _id: '',
      statements: [],
      users: [],
      projectId: '',
      name: '',
      createdAt: '',
      updatedAt: '',
    },
  },
  isLoading: false,
};

export const project = (state = initState, action: ProjectType) => {
  switch (action.type) {
    case 'KEY_PROJECT_SELECT_ID':
      return { ...state, id: action.payload.id, name: action.payload.name };
    case 'KEY_PROJECT_CLEAR_SELECT':
      state.id = '';
      state.name = '';
      return { ...state };
    case 'KEY_PROJECT_SET_DATA':
      return { ...state, data: action.payload.data, meta: action.payload.meta };
    case 'KEY_PROJECT_SET_WITHID':
      state.currentProject = action.payload;
      return { ...state };
    case 'KEY_PROJECT_SET_CURRENTROLE':
      state.listRole.currentRole = action.payload;
      return { ...state };
    case 'KEY_PROJECT_CLEAR_CURRENTROLE':
      state.listRole.currentRole = undefined;
      return { ...state };
    case 'KEY_PROJECT_SET_LISTROLES':
      state.listRole.data = action.payload.data;
      state.listRole.meta = action.payload.meta;
      return { ...state };
    case 'KEY_PROJECT_LIST_GROUPS':
      state.isLoading = true;
      return { ...state };
    case 'KEY_PROJECT_LIST_GROUPS_END_USER':
      state.isLoading = true;
      return { ...state };
    case 'KEY_PROJECT_CLEAR_LOADING':
      state.isLoading = false;
      return { ...state };
    case 'KEY_PROJECT_CLEAR_CURRENTID':
      state.currentProject._id = '';
      return { ...state };
    default:
      return state;
  }
};
